(function () {
  'use strict';

  var prompt = document.querySelector('[data-email-prompt]');
  if (!prompt) return;

  var teaser = prompt.querySelector('[data-email-prompt-teaser]');
  var panel = prompt.querySelector('[data-email-prompt-panel]');
  var openButton = prompt.querySelector('[data-email-prompt-open]');
  var closeButtons = prompt.querySelectorAll('[data-email-prompt-close]');
  var form = prompt.querySelector('.email-prompt__form');
  var email = prompt.querySelector('input[type="email"]');
  var article = document.querySelector('.article');
  var success = prompt.querySelector('[data-email-prompt-success]');
  var error = prompt.querySelector('[data-email-prompt-error]');
  var delay = Math.max(0, parseInt(prompt.getAttribute('data-delay-ms'), 10) || 0);
  var scrollThreshold = Math.min(100, Math.max(0, parseInt(prompt.getAttribute('data-scroll-percent'), 10) || 60));
  var dismissDays = Math.max(1, parseInt(prompt.getAttribute('data-dismiss-days'), 10) || 30);
  var storageKey = 'hg-email-prompt-v1';
  var delayReady = delay === 0;
  var scrollReady = false;
  var revealed = false;

  function readState() {
    try {
      return JSON.parse(window.localStorage.getItem(storageKey) || '{}');
    } catch (_error) {
      return {};
    }
  }

  function writeState(value) {
    try {
      var next = readState();
      Object.keys(value).forEach(function (key) { next[key] = value[key]; });
      window.localStorage.setItem(storageKey, JSON.stringify(next));
    } catch (_error) {
      /* Privat läge kan neka lagring. Prompten fungerar ändå på sidan. */
    }
  }

  function track(name) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('hjartgruppen:' + name, { placement: 'guide_email_prompt' });
      }
    } catch (_error) {
      /* Analys får aldrig blockera formuläret eller stängningen. */
    }
  }

  function reveal() {
    if (revealed) return;
    revealed = true;
    prompt.hidden = false;
    window.requestAnimationFrame(function () {
      prompt.classList.add('is-visible');
    });
    track('email_prompt_viewed');
  }

  function showPanel() {
    teaser.hidden = true;
    panel.hidden = false;
    openButton.setAttribute('aria-expanded', 'true');
    reveal();
    if (email) window.setTimeout(function () { email.focus(); }, 0);
  }

  function dismiss() {
    writeState({ dismissUntil: Date.now() + dismissDays * 86400000 });
    prompt.classList.remove('is-visible');
    window.setTimeout(function () { prompt.hidden = true; }, 220);
    track('email_prompt_dismissed');
  }

  function scrollProgress() {
    var scrollY = window.scrollY || window.pageYOffset || 0;

    if (article) {
      var articleTop = article.getBoundingClientRect().top + scrollY;
      var articleDistance = Math.max(0, article.offsetHeight - window.innerHeight);
      if (articleDistance === 0) return scrollY >= articleTop ? 100 : 0;
      return Math.min(100, Math.max(0, (scrollY - articleTop) / articleDistance * 100));
    }

    var root = document.documentElement;
    var available = Math.max(0, root.scrollHeight - window.innerHeight);
    if (available === 0) return 0;
    return Math.min(100, Math.max(0, scrollY / available * 100));
  }

  function onScroll() {
    scrollReady = scrollProgress() >= scrollThreshold;
    if (scrollReady) window.removeEventListener('scroll', onScroll);
    maybeReveal();
  }

  function maybeReveal() {
    if (delayReady && scrollReady) reveal();
  }

  if (success) {
    writeState({ subscribed: true });
    showPanel();
    track('email_prompt_subscribed');
  } else if (error) {
    showPanel();
  } else {
    var state = readState();
    if (state.subscribed || Number(state.dismissUntil) > Date.now()) return;

    scrollReady = scrollProgress() >= scrollThreshold;
    if (!scrollReady) window.addEventListener('scroll', onScroll, { passive: true });

    if (!delayReady) {
      window.setTimeout(function () {
        delayReady = true;
        maybeReveal();
      }, delay);
    }
    maybeReveal();
  }

  openButton.addEventListener('click', function () {
    showPanel();
    track('email_prompt_opened');
  });

  Array.prototype.forEach.call(closeButtons, function (button) {
    button.addEventListener('click', dismiss);
  });

  if (form) {
    form.addEventListener('submit', function () {
      track('email_prompt_submitted');
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !prompt.hidden) dismiss();
  });
})();
